import templateUrl from './emailTemplateNotifyBlock.tpl.html';

angular.module('signalview.detector.notification').directive('emailTemplateNotifyBlock', [
    '$timeout',
    function ($timeout) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                model: '=ngModel',
                emailTemplates: '<',
                emailTemplatesLoading: '<?',
                remove: '&onRemove',
                readOnly: '=?',
                doneEdit: '&onFinishEdit',
            },
            templateUrl,
            link: function ($scope) {
                $scope.emailTemplates = $scope.emailTemplates || [];

                function syncSelectedEmailTemplate() {
                    $scope.emailTemplates = $scope.emailTemplates || [];
                    $scope.emailTemplate = null;
                    $scope.editable =
                        !$scope.emailTemplatesLoading && $scope.emailTemplates.length > 1;

                    if (!$scope.model.templateId) {
                        $scope.editable =
                            !$scope.emailTemplatesLoading && $scope.emailTemplates.length > 0;
                        return;
                    }

                    $scope.emailTemplates.some(function (emailTemplate) {
                        if (emailTemplate.id === $scope.model.templateId) {
                            $scope.emailTemplate = emailTemplate;
                            return true;
                        }
                    });

                    if (!$scope.emailTemplate) {
                        $scope.editable = !$scope.emailTemplatesLoading;
                    }
                }

                $scope.setEmailTemplate = function (emailTemplate) {
                    $scope.model.templateId = emailTemplate.id;
                    $scope.emailTemplate = emailTemplate;
                };

                $scope.finishEdit = function (emailTemplate) {
                    if (emailTemplate) {
                        $scope.setEmailTemplate(emailTemplate);
                    }

                    if ($scope.model.templateId) {
                        $scope.edit = false;
                    } else if ($scope.remove) {
                        $scope.remove();
                    }

                    if ($scope.doneEdit) {
                        $scope.doneEdit();
                    }
                };

                $scope.$watch('dropdownOpen', function (newValue, oldValue) {
                    if (oldValue && !newValue) {
                        if (!$scope.model.templateId && $scope.remove) {
                            $scope.remove();
                        }
                    }
                });

                $scope.editMode = function () {
                    if (!$scope.editable) {
                        return;
                    }

                    $scope.edit = true;
                    $timeout(function () {
                        $scope.dropdownOpen = true;
                    });
                };

                $scope.editable = !$scope.emailTemplatesLoading && $scope.emailTemplates.length > 1;

                if (!$scope.model.templateId) {
                    if ($scope.emailTemplates.length === 1) {
                        $scope.setEmailTemplate($scope.emailTemplates[0]);
                        if ($scope.doneEdit) {
                            $scope.doneEdit();
                        }
                    } else {
                        $scope.editable =
                            !$scope.emailTemplatesLoading && $scope.emailTemplates.length > 0;
                        $scope.editMode();
                    }
                } else {
                    syncSelectedEmailTemplate();
                }

                $scope.$watchCollection('emailTemplates', syncSelectedEmailTemplate);
                $scope.$watch('model.templateId', syncSelectedEmailTemplate);
                $scope.$watch('emailTemplatesLoading', syncSelectedEmailTemplate);
            },
        };
    },
]);
